<template>
  <v-dialog :value="dialogProp.show" persistent max-width="600">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Редактирование настроек сегмента') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text>
        <v-row class="pa-2">
          <v-col>
            <ValidationObserver ref="settings">
              <template
                  v-for="(prop) in settings">
                <validatable-text-input
                    v-if="prop.dataType === 'string'"
                    :key="prop.propertyName"
                    v-model="prop.stringValue"
                    :readonly="!prop.canEdit"
                    prepend-icon="title"
                    :rules="{ required: prop.required,
                              regex: prop.regex }"
                    :label="$t(prop.description)" />
                <validatable-date-picker
                    v-if="prop.dataType === 'dateTime'"
                    :key="prop.propertyName"
                    v-model="prop.dateValue"
                    :readonly="!prop.canEdit"
                    :rules="{ required: prop.required }"
                    :label="$t(prop.description)" />
              </template>
            </ValidationObserver>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueBtn"
            v-test="{ btn: 'continue' }"
            color="primary"
            @click.stop="send">
          {{ $t('Изменить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import ValidatableDatePicker from '@/components/reused/ui/ValidatableDatePicker.vue'

  import { mapActions } from 'vuex'
  import { SYSTEM_SETTINGS } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      ValidatableTextInput,
      ValidatableDatePicker
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            show: false,
            settings: null,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        isLoading: false,
        settings: []
      }
    },
    watch: {
      'dialogProp.settings': {
        immediate: true,
        handler (newValue) {
          this.settings = newValue.map(s => ({
            ...s,
            canEdit: this.isMainAdmin || s.propertyName !== 'segmentIdentifier',
            regex: s.propertyName === 'segmentIdentifier' ? /^[a-zA-Z0-9.-]*$/ : false
          }))
          this.$forceUpdate()
        }
      }
    },
    methods: {
      ...mapActions(SYSTEM_SETTINGS.NAMESPACE, {
        editSegmentConfigurationAction: SYSTEM_SETTINGS.ACTIONS.EDIT_SEGMENT_CONFIGURATION
      }),
      send: async function () {
        const result = await this.$refs.settings.validate()
        if (!result) {
          return
        }
        try {
          this.isLoading = true
          await this.editSegmentConfigurationAction(this.settings)
          this.isLoading = false
          if (this.dialogProp.callback) {
            this.dialogProp.callback()
          }
          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
